module.exports = __webpack_public_path__ + "static/media/bni.2a879caa.svg";